<template>
	<div class="page-sign d-block py-0">
		<div class="row g-0">
			<div class="col-md-7 col-lg-5 col-xl-6 col-wrapper">
				<div class="card card-sign">
					<div class="card-header">
						<div class="row mb-2 gap-2">
							<div class="col-2">
								<img src="assets/img/hassan_police_logo.jpeg" class="img" width="50" height="50" />
							</div>
							<div class="col-8">
								<a href="#" class="text-center h3 header-logo mb-0">RS 1059</a>
								<p class="card-text fs-12">Portal for Hassan City Police</p>
							</div>
						</div>

						<!-- <img src="assets/img/logo.jpg" class="img" width="100" />
                            <a href="#" class="text-center header-logo mb-3 mt-2">Rowdies Gangs</a> -->

						<h4 class="card-title1 fw-700 text-dark">Login to your account!</h4>
						<!-- <p class="card-text">Welcome back! Please signin to continue.</p> -->
					</div>
					<div class="card-body">
						<div class="mb-4">
							<label class="form-label mb-0">Phone Number</label>
							<!-- <input type="text" class="form-control border-0 border-bottom " placeholder="Enter your email address"/> -->
							<div class="input-group border-bottom">
								<div class="input-group-text border-0  bg-white">+91-</div>
								<input type="text" @keypress="isNumber($event)" maxlength="10"
									class="form-control border-0" :class="{ 'is-invalid': errors?.mobile_no }"
									id="autoSizingInputGroup" ref="mobile_no" placeholder="O O O O O O O O O O "
									v-model="user.mobile_no" :disabled="otp_status" @keydown.enter="sendOtp()" />
								<div class="input-group-text border-0  bg-white"><img class="img_flag"
										src="assets/img/flag.png" width="100" /></div>
								<span v-if="errors?.mobile_no" class="invalid-feedback">{{ errors?.mobile_no[0]
								}}</span>
							</div>
							<div v-if="!otp_status" class="float-end mb-4 mt-2"><a href="javascript:void(0)"
									@click="sendOtp()">REQUEST
									OTP</a></div>
						</div>
						<div v-if="otp_status">
							<div class="mb-4">
								<label class="form-label d-flex justify-content-between mb-0">OTP</label>
								<div class="inputs d-flex flex-row justify-content-center my-2">
									<v-otp-input ref="otpInput"
										input-classes="otp-input m-1 text-center form-control inputotp"
										:conditionalClass="p - otp" separator="" inputType="letter-numeric"
										:num-inputs="6" v-model:value="p_otp1" :should-auto-focus="true"
										:should-focus-order="true" @on-change="handleOnChange"
										@on-complete="verifyOtp()" />
								</div>

								<div class="float-end mb-4"><a href="javascrit:void(0)" @click="resendOtp()"
										style="color:#6e7985;"><span><i class="h4 ri-restart-line me-2"
												style="color: black;"></i></span>RESEND THE OTP</a></div>
							</div>
							<button class="btn btn-primary btn-sign" @click="verifyOtp()">Login To Continue </button>
						</div>
					</div>
					<img src="assets/img/bg3.png" class="img2">
				</div>
			</div>
			<div class="col d-none d-lg-block" style="position: relative;"><img src="assets/img/HASSAN POL IMG.jpeg"
					class="auth-img" alt="" />
				<!-- <p class="kan_text text-white">ದೇವರನ್ನು ಪೂಜಿಸಿದರೆ ದೇವರಾಗುತ್ತೇವೆ, ದೆವ್ವಗಳನ್ನು ಪೂಜಿಸಿದರೆ
                    ದೆವ್ವಗಳಾಗುತ್ತೇವೆ.<br>– ಕುವೆಂಪು, ಆತ್ಮಶ್ರೀಗಾಗಿ ನಿರಂಕುಶಮತಿಗಳಾಗಿ, ಪುಟ ೧೮</p> -->
			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios';
import { getValidationUrl } from '@/config/policeapp.js';

export default {
	name: "Login",
	data() {
		return {
			user: {
				mobile_no: "",
				otp: "",
			},
			errors: [],
			otp_status: false,
			p_otp: {
				first: '',
				second: '',
				third: '',
				fourth: '',
				fifth: '',
				sixth: ''
			},
			p_otp1: '',
			source: null
		};
	},
	mounted() {
		this.$refs.mobile_no.focus();
		this.handlePoliceAppSSO();
	},

	methods: {
		focusInput(e) {
			const input = e.target;
			let value = input.value;
			let isValidInput = value.match(/[0-9a-z]/gi);
			input.value = "";
			input.value = isValidInput ? value[0] : "";
			let fieldIndex = input.dataset.index;
			console.log("fieldIndex", fieldIndex)
			// if (fieldIndex < inputs.length - 1 && isValidInput) {
			//     input.nextElementSibling.focus();
			// }
		},
		sendOtp() {
			let vm = this;
			let loader = vm.$loading.show();
			
			// Check if this is from police app
			const urlParams = new URLSearchParams(window.location.search);
			const source = urlParams.get('source');
			
			// Prepare data with source if from police app
			let requestData = { ...vm.user };
			if (source === 'police_app') {
				requestData.source = 'police_app';
			}
			
			vm.$store.dispatch("auth", { uri: "sendOtp", data: requestData })
				.then(function () {
					vm.otp_status = true;
					loader.hide();
					vm.errors = [];
					// vm.$refs.otp.focus();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		resendOtp() {
			let vm = this;
			let loader = vm.$loading.show();
			vm.$store.dispatch("auth", { uri: "resendOtp", data: vm.user })
				.then(function () {
					vm.status = true;
					loader.hide();
					vm.errors = [];
					// vm.$refs.otp.focus();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		verifyOtp() {
			let vm = this;
			let otp = [this.p_otp.first, this.p_otp.second, this.p_otp.third, this.p_otp.fourth, this.p_otp.fifth, this.p_otp.sixth];
			this.user.otp = otp.join('');
			console.log("otp", vm.p_otp1)
			vm.user.otp = vm.p_otp1
			
			// Use source from decrypted token or URL parameters
			let source = vm.source;
			if (!source) {
				const urlParams = new URLSearchParams(window.location.search);
				source = urlParams.get('source');
			}
			
			// Prepare data with source if available
			let requestData = { ...vm.user };
			if (source) {
				requestData.source = source;
			}
			
			let loader = vm.$loading.show();
			vm.$store.dispatch("auth", { uri: "verifyOtp", data: requestData })
				.then(function (response) {
					loader.hide();
					vm.otp_status = false
					vm.$store.dispatch('setPermissions', response.data.permissions);
					vm.$store.dispatch("setUser", response.data.user);
					vm.$store.dispatch("setToken", response.data.token);
					sessionStorage.setItem("path", "/all_rowdy_list");
					// vm.$store.dispatch("setPermissions", response.data.permissions);
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		isNumber(e) {
			const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
			const keyPressed = e.key;
			if (!keysAllowed.includes(keyPressed)) {
				e.preventDefault()
			}
		},

		handlePoliceAppSSO() {
			console.log("handlePoliceAppSSO")
			// Check for URL parameters from police app
			// Handle both hash-based (#/?tokenId=...) and query-based (?tokenId=...) parameters
			
			let tokenId = null;
			
			// First try hash-based parameters (Vue Router style)
			const hash = window.location.hash;
			console.log("hash", hash);
			
			if (hash.includes('?')) {
				const hashQuery = hash.split('?')[1];
				console.log("hashQuery", hashQuery);
				const hashParams = new URLSearchParams(hashQuery);
				tokenId = hashParams.get('tokenId');
				console.log("tokenId from hash:", tokenId);
			}
			
			// If not found in hash, try query parameters
			if (!tokenId) {
				const urlParams = new URLSearchParams(window.location.search);
				tokenId = urlParams.get('tokenId');
				console.log("tokenId from query:", tokenId);
			}

			console.log("Final tokenId:", tokenId)
			// Handle tokenId-based authentication (new approach)
			if (tokenId) {
				console.log("handlePoliceAppSSO tokenId",tokenId)
				this.handleTokenIdAuthentication(tokenId);
				return;
			}
		},

		handleTokenIdAuthentication(tokenId) {
			console.log("handleTokenIdAuthentication",tokenId)
			let vm = this;
			let loader = vm.$loading.show();
			
			// Make direct HTTP request to CID app for tokenId validation
			const validateUrl = getValidationUrl();
			console.log("validateURL",validateUrl);
			const requestData = {
				tokenId: tokenId
			};
			
			// Debug logging
			console.log('TokenId validation attempt:', {
				tokenId: tokenId,
				validateUrl: validateUrl,
				requestData: requestData
			});
			
			// Use axios directly to call CID app
			axios.post(validateUrl, requestData)
				.then(function (response) {
					loader.hide();
					console.log("response",response)
					if (response.data.success) {
						// Response format: { success: true, mobile_number: "...", source: "...", ... }
						const userData = response.data;
						
						// Auto-fill mobile number from validated tokenId
						vm.user.mobile_no = userData.mobile_number;
						
						// Set source for OTP request
						vm.source = userData.source || 'police_app';
						
						// Auto-trigger OTP sending with validated data
						vm.sendOtpWithSource(userData.mobile_number, vm.source);
					} else {
						vm.$store.dispatch("error", response.data.message || "Invalid or expired tokenId");
					}
					
					// Clear URL parameters after processing
					window.history.replaceState({}, document.title, window.location.pathname);
				})
				.catch(function (error) {
					loader.hide();
					console.error('TokenId validation error:', error);
					vm.$store.dispatch("error", "TokenId validation failed");
					
					// Clear URL parameters even on error
					window.history.replaceState({}, document.title, window.location.pathname);
				});
		},

		sendOtpWithSource(mobileNumber, source) {
			let vm = this;
			let loader = vm.$loading.show();
			
			// Prepare data with source from decrypted token
			let requestData = {
				mobile_no: mobileNumber,
				source: source
			};
			
			vm.$store.dispatch("auth", { uri: "sendOtp", data: requestData })
				.then(function () {
					vm.otp_status = true;
					loader.hide();
					vm.errors = [];
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		}
	},
};
</script>
<style scoped>
.fw-700 {
	font-weight: 700;
}

.img_flag {
	height: 20px;
	width: 25px;
}

.auth-img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center center;
	mix-blend-mode: normal !important;
	opacity: inherit !important;
}

.fs-12 {
	font-size: 12px;
}

.img2 {
	opacity: 15%;
	width: 163px;
	height: 122px;
	top: 873px;
	left: 21px;
}

.kan_text {
	position: absolute;
	left: 40px;
	bottom: 8px;
	/* width:498px */
}

.inputotp {
	height: 50px !important;
	width: 50px !important;
	margin: 2px !important;
}

/*.otp-input {
    padding: 5px;
    margin: 2 10px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
    height: 50px;
    width: 50px;
  }*/
/* Background colour of an input field with value */
/* .otp-input.is-complete {
    background-color: #e4e4e4;
  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;

  }*/
input::placeholder {
	font-size: 15px;
	font-weight: 600;


}

input:-internal-autofill-selected {
	appearance: menulist-button;
	background-image: none !important;
	background-color: white !important;
	color: fieldtext !important;
}


.card-sign .form-control,
.otp-input {
	font-weight: 500;
	color: #212830;
	height: 50px !important;
	width: 50px;
	margin: 2px;
}

.form-control:focus {
	border-color: inherit;
	-webkit-box-shadow: none;
	box-shadow: none;
}
</style>
